import { createContext, useState } from "react";
import { jsonConfig } from '../Config';

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {

    const [signed, setSigned] = useState(false)
    const [signedInvestidor, setSignedInvestidor] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isEdit, setIsEdit] = useState(false)

    const [email, setEmail] = useState('')
    const [senha, setSenha] = useState('')

    const [modalMsg, setModalMsg] = useState(false)
    const [msgModalMsg, setMsgModalMsg] = useState('')
    const [descModalMsg, setDescModalMsg] = useState('')
    const [titleButtonModalMsg, setTitleButtonModalMsg] = useState('Retornar')
    const [titleButtonCloseModalMsg, setTitleButtonCloseModalMsg] = useState('Fechar')
    const [perigoModalMsg, setPerigoModalMsg] = useState(false)
    const [functionModalMsg, setFunctionModalMsg] = useState(() => { })

    const [sideBar, setSideBar] = useState(false)


    const [dataEstatisticaRecuperacaoSenha, setDataEstatisticaRecuperacaoSenha] = useState([])
    const [dataRecuperacaoSenha, setDataRecuperacaoSenha] = useState([])
    const [RecuperacaoSenha, setRecuperacaoSenha] = useState({})
    const [offsetRecuperacaoSenha, setOffsetRecuperacaoSenha] = useState(0)
    const [limiteRecuperacaoSenha, setLimiteRecuperacaoSenha] = useState(jsonConfig.limitDefault)
    const [limiteBuscaRecuperacaoSenha, setLimiteBuscaRecuperacaoSenha] = useState(false)

    const [dataEstatisticaUsuarios, setDataEstatisticaUsuarios] = useState([])
    const [dataUsuarios, setDataUsuarios] = useState([])
    const [Usuarios, setUsuarios] = useState({})
    const [offsetUsuarios, setOffsetUsuarios] = useState(0)
    const [limiteUsuarios, setLimiteUsuarios] = useState(jsonConfig.limitDefault)
    const [limiteBuscaUsuarios, setLimiteBuscaUsuarios] = useState(false)
    const [modalUsuarios, setModalUsuarios] = useState(false)

    const [dataEstatisticaLogs, setDataEstatisticaLogs] = useState([])
    const [dataLogs, setDataLogs] = useState([])
    const [Logs, setLogs] = useState({})
    const [offsetLogs, setOffsetLogs] = useState(0)
    const [limiteLogs, setLimiteLogs] = useState(jsonConfig.limitDefault)
    const [limiteBuscaLogs, setLimiteBuscaLogs] = useState(false)
    const [modalLogs, setModalLogs] = useState(false)


    //Page, per_page, sort, sort_dir, filter
    const [page, setPage] = useState(0)
    const [per_page, setPer_page] = useState(jsonConfig.limitDefault)
    const [sort, setSort] = useState("data_criacao")
    const [sort_dir, setSort_dir] = useState("desc")
    const [filter, setFilter] = useState(null)

    const [dataEstatisticaRequests, setDataEstatisticaRequests] = useState([])
    const [dataRequests, setDataRequests] = useState([])
    const [Requests, setRequests] = useState({})
    const [offsetRequests, setOffsetRequests] = useState(0)
    const [limiteRequests, setLimiteRequests] = useState(jsonConfig.limitDefault)
    const [limiteBuscaRequests, setLimiteBuscaRequests] = useState(false)
    const [modalRequests, setModalRequests] = useState(false)



    const [dataEstatisticaInvestidores, setDataEstatisticaInvestidores] = useState([])
    const [dataInvestidores, setDataInvestidores] = useState([])
    const [Investidores, setInvestidores] = useState({})
    const [offsetInvestidores, setOffsetInvestidores] = useState(0)
    const [limiteInvestidores, setLimiteInvestidores] = useState(jsonConfig.limitDefault)
    const [limiteBuscaInvestidores, setLimiteBuscaInvestidores] = useState(false)
    const [modalInvestidores, setModalInvestidores] = useState(false)
    const [modalViewInvestidores, setModalViewInvestidores] = useState(false)

    const [dataEstatisticaInvestimentos, setDataEstatisticaInvestimentos] = useState([])
    const [dataInvestimentos, setDataInvestimentos] = useState([])
    const [Investimentos, setInvestimentos] = useState({})
    const [offsetInvestimentos, setOffsetInvestimentos] = useState(0)
    const [limiteInvestimentos, setLimiteInvestimentos] = useState(jsonConfig.limitDefault)
    const [limiteBuscaInvestimentos, setLimiteBuscaInvestimentos] = useState(false)
    const [modalInvestimentos, setModalInvestimentos] = useState(false)
    const [modalViewInvestimentos, setModalViewInvestimentos] = useState(false)


    const [dataEmpreendimentos, setDataEmpreendimentos] = useState([])

    const [dataEstatisticaObras, setDataEstatisticaObras] = useState([])
    const [dataObras, setDataObras] = useState([])
    const [Obras, setObras] = useState({})
    const [offsetObras, setOffsetObras] = useState(0)
    const [limiteObras, setLimiteObras] = useState(jsonConfig.limitDefault)
    const [limiteBuscaObras, setLimiteBuscaObras] = useState(false)
    const [modalObras, setModalObras] = useState(false)
    const [modalViewObras, setModalViewObras] = useState(false)

    const [dataEstatisticaInvestidoresInvestimentos, setDataEstatisticaInvestidoresInvestimentos] = useState([])
    const [dataInvestidoresInvestimentos, setDataInvestidoresInvestimentos] = useState([])
    const [InvestidoresInvestimentos, setInvestidoresInvestimentos] = useState({})
    const [offsetInvestidoresInvestimentos, setOffsetInvestidoresInvestimentos] = useState(0)
    const [limiteInvestidoresInvestimentos, setLimiteInvestidoresInvestimentos] = useState(jsonConfig.limitDefault)
    const [limiteBuscaInvestidoresInvestimentos, setLimiteBuscaInvestidoresInvestimentos] = useState(false)
    const [modalInvestidoresInvestimentos, setModalInvestidoresInvestimentos] = useState(false)
    const [modalViewInvestidoresInvestimentos, setModalViewInvestidoresInvestimentos] = useState(false)

    // Estoque da Obra
    const [dataEstoque, setDataEstoque] = useState([])
    const [dataEstatisticasEstoque, setDataEstatisticasEstoque] = useState({ cards: [], statusCards: [], top5: [] })

    // Vendas da Obra
    const [dataVendas, setDataVendas] = useState([])
    const [dataEstatisticasVendas, setDataEstatisticasVendas] = useState({ cards: [], graficoMensal: [] })

    // Recebidos da Obra
    const [dataRecebidos, setDataRecebidos] = useState([])
    const [dataEstatisticasRecebidos, setDataEstatisticasRecebidos] = useState({ cards: [], graficoMensal: [] })

    // A Receber da Obra
    const [dataAReceber, setDataAReceber] = useState([])
    const [dataEstatisticasAReceber, setDataEstatisticasAReceber] = useState({ cards: [], graficoMensal: [] })

    // Movimentação Financeira da Obra
    const [dataMovimentacao, setDataMovimentacao] = useState([])
    const [dataEstatisticasMovimentacao, setDataEstatisticasMovimentacao] = useState({ cards: [], graficoMensal: [], dre: { receitas: [], despesas: [], impostos: [], totalReceitas: 0, totalDespesas: 0, totalImpostos: 0, resultado: 0 } })

    //#endregion

    const states = {
        // Paginação e filtros
        page,
        per_page,
        sort,
        sort_dir,
        filter,
        // Requests
        dataEstatisticaRequests,
        dataRequests,
        Requests,
        offsetRequests,
        limiteRequests,
        limiteBuscaRequests,
        modalRequests,
        // Logs
        dataEstatisticaLogs,
        dataLogs,
        Logs,
        offsetLogs,
        limiteLogs,
        limiteBuscaLogs,
        modalLogs,
        // Usuários
        dataEstatisticaUsuarios,
        dataUsuarios,
        Usuarios,
        offsetUsuarios,
        limiteUsuarios,
        limiteBuscaUsuarios,
        modalUsuarios,
        // Recuperação de Senha
        dataEstatisticaRecuperacaoSenha,
        dataRecuperacaoSenha,
        RecuperacaoSenha,
        offsetRecuperacaoSenha,
        limiteRecuperacaoSenha,
        limiteBuscaRecuperacaoSenha,

        // Investidores
        dataEstatisticaInvestidores,
        dataInvestidores,
        Investidores,
        offsetInvestidores,
        limiteInvestidores,
        limiteBuscaInvestidores,
        modalInvestidores,
        modalViewInvestidores,

        // Investimentos
        dataEstatisticaInvestimentos,
        dataInvestimentos,
        Investimentos,
        offsetInvestimentos,
        limiteInvestimentos,
        limiteBuscaInvestimentos,
        modalInvestimentos,
        modalViewInvestimentos,


        // Empreendimentos do investidor
        dataEmpreendimentos,

        // Obras
        dataEstatisticaObras,
        dataObras,
        Obras,
        offsetObras,
        limiteObras,
        limiteBuscaObras,
        modalObras,
        modalViewObras,

        // InvestidoresInvestimentos
        dataEstatisticaInvestidoresInvestimentos,
        dataInvestidoresInvestimentos,
        InvestidoresInvestimentos,
        offsetInvestidoresInvestimentos,
        limiteInvestidoresInvestimentos,
        limiteBuscaInvestidoresInvestimentos,
        modalInvestidoresInvestimentos,
        modalViewInvestidoresInvestimentos,

        // Estoque da Obra
        dataEstoque,
        dataEstatisticasEstoque,

        // Vendas da Obra
        dataVendas,
        dataEstatisticasVendas,

        // Recebidos da Obra
        dataRecebidos,
        dataEstatisticasRecebidos,

        // A Receber da Obra
        dataAReceber,
        dataEstatisticasAReceber,

        // Movimentação Financeira da Obra
        dataMovimentacao,
        dataEstatisticasMovimentacao,

        // Estados gerais
        signed,
        isLoading,
        email,
        senha,
        modalMsg,
        msgModalMsg,
        descModalMsg,
        perigoModalMsg,
        titleButtonModalMsg,
        functionModalMsg,
        titleButtonCloseModalMsg,
        sideBar,
        isEdit,
        signedInvestidor
    }

    const setters = {
        // Paginação e filtros
        setPage,
        setPer_page,
        setSort,
        setSort_dir,
        setFilter,
        // Requests
        setDataEstatisticaRequests,
        setDataRequests,
        setRequests,
        setOffsetRequests,
        setLimiteRequests,
        setLimiteBuscaRequests,
        setModalRequests,
        // Logs
        setDataEstatisticaLogs,
        setDataLogs,
        setLogs,
        setOffsetLogs,
        setLimiteLogs,
        setLimiteBuscaLogs,
        setModalLogs,
        // Usuários
        setDataEstatisticaUsuarios,
        setDataUsuarios,
        setUsuarios,
        setOffsetUsuarios,
        setLimiteUsuarios,
        setLimiteBuscaUsuarios,
        setModalUsuarios,
        // Recuperação de Senha
        setDataEstatisticaRecuperacaoSenha,
        setDataRecuperacaoSenha,
        setRecuperacaoSenha,
        setOffsetRecuperacaoSenha,
        setLimiteRecuperacaoSenha,
        setLimiteBuscaRecuperacaoSenha,
        // Investidores
        setDataEstatisticaInvestidores,
        setDataInvestidores,
        setInvestidores,
        setOffsetInvestidores,
        setLimiteInvestidores,
        setLimiteBuscaInvestidores,
        setModalInvestidores,
        setModalViewInvestidores,
        // Investimentos
        setDataEstatisticaInvestimentos,
        setDataInvestimentos,
        setInvestimentos,
        setOffsetInvestimentos,
        setLimiteInvestimentos,
        setLimiteBuscaInvestimentos,
        setModalInvestimentos,
        setModalViewInvestimentos,


        // Empreendimentos do investidor
        setDataEmpreendimentos,

        // Obras
        setDataEstatisticaObras,
        setDataObras,
        setObras,
        setOffsetObras,
        setLimiteObras,
        setLimiteBuscaObras,
        setModalObras,
        setModalViewObras,

        // InvestidoresInvestimentos
        setDataEstatisticaInvestidoresInvestimentos,
        setDataInvestidoresInvestimentos,
        setInvestidoresInvestimentos,
        setOffsetInvestidoresInvestimentos,
        setLimiteInvestidoresInvestimentos,
        setLimiteBuscaInvestidoresInvestimentos,
        setModalInvestidoresInvestimentos,
        setModalViewInvestidoresInvestimentos,

        // Estoque da Obra
        setDataEstoque,
        setDataEstatisticasEstoque,

        // Vendas da Obra
        setDataVendas,
        setDataEstatisticasVendas,

        // Recebidos da Obra
        setDataRecebidos,
        setDataEstatisticasRecebidos,

        // A Receber da Obra
        setDataAReceber,
        setDataEstatisticasAReceber,

        // Movimentação Financeira da Obra
        setDataMovimentacao,
        setDataEstatisticasMovimentacao,

        // Estados gerais
        setSigned,
        setIsLoading,
        setEmail,
        setSenha,
        setModalMsg,
        setMsgModalMsg,
        setDescModalMsg,
        setPerigoModalMsg,
        setTitleButtonModalMsg,
        setFunctionModalMsg,
        setTitleButtonCloseModalMsg,
        setSideBar,
        setIsEdit,
        setSignedInvestidor
    }




    return (
        <AuthContext.Provider
            value={{
                states,
                setters
            }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthProvider;
